<template>
  <div class="prop-tab">
    <div class="slide">
      <div class="title">
        <img :src="title">
      </div>
    </div>
    <m-textArea class="data-list" ref="dataList">
      <div class="picture-list">
        <div
          v-for="(item, index) in datalist"
          :key="index"
          class="picture-item"
          @click="$emit('picshow', item)"
        >
          <div class="picture-main">
            <img :src="item.preview_url">
          </div>
          <div class="picture-tt">
            {{item.title}}
          </div>
        </div>
      </div>
      <Pagination
        :num="pageNow"
        :pages="pages"
        @change="chagenPage"
      ></Pagination>
    </m-textArea>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import TextArea from "@/components/TextArea";
import Pagination from "@/components/Pagination";

export default {
  props: {
    tabData: Object
  },
  components: {
    "m-textArea": TextArea,
    Pagination
  },
  data() {
    return {
      dataName: "prop"
    };
  },
  computed: {
    ...mapState(["prop"]),
    datalist() {
      return this.prop[this.pageNow];
    },
    pageNow() {
      return this.prop.number;
    },
    pages() {
      return this.prop.total_pages;
    },
    title() {
      return this.tabData.ttimg;
    }
  },
  filters: {},
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["getDataList"]),
    getPageData(page_num = 0) {
      const param = {
        data_name: this.dataName,
        page_size: 24,
        page_num
      };
      this.getDataList(param);
    },
    chagenPage(num) {
      this.getPageData(num);
      this.$refs.dataList.scroll();
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.prop-tab {
  position: relative;
  display: flex;
  height: 73vh;
  padding: 1rem 1rem 0;
  overflow: hidden;

  .slide {
    position: relative;
    flex: 1;

    .title {
      position: absolute;
      top: 3rem;
      @include scaleimg(0.5);
    }

    .gisbtn {
      position: absolute;
      left: 0.5rem;
      bottom: 1rem;
    }
  }

  .data-list {
    position: relative;
    flex: 5;
    height: 100%;

    .text-main {
      padding: 1rem 0;
    }
  }

  .picture-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 1rem;
    padding: 0 0.5rem;
    .picture-item {
      width: 48%;
      margin-bottom: 0.65rem;
      padding: 0.5rem;
      background-color: #d2c2a3;

      .picture-main {
        height: 6rem;
        text-align: center;
        line-height: 6rem;
        img {
          max-width: 100%;
          max-height: 100%;
          vertical-align: middle;
        }
      }

      .picture-tt {
        font-size: 0.75rem;
        text-align: center;
      }
    }
  }
}
</style>
